import store from "@/state/store";

export default [
  {
    path: "/dashboard",
    name: "dashboards",

    meta: {
      authRequired: true,
    },
    component: () => import("./views/dashboards/default"),
  },

  {
    path: "/",
    name: "landing",

    component: () => import("./views/landing/landing"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("./views/account/login"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/authenticated"]) {
          // Redirect to the home page instead

          next({ name: "dashboards" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("./views/account/register"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/authenticated"]) {
          // Redirect to the home page instead
          next({ name: "dashboards" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("./views/account/forgot-password"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/authenticated"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/reset-password/:token",
    name: "Reset password",
    component: () => import("./views/account/reset-password"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/authenticated"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/logout",
    name: "logout",
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/404",
    name: "404",
    component: require("./views/utility/404").default,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: "*",
    redirect: "404",
  },
  // Quotes
  {
    path: "/quotes/create",
    name: "quote-create",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/quote/create"),
  },
  {
    path: "/quotes",
    name: "quotes-list",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/quote/list"),
  },
  {
    path: "/quotes/:id",
    name: "quote-details",
    meta: {
      authRequired: true,
    },
    props: true,
    component: () => import("./views/quote/show"),
  },
  // inbound-shipments
  {
    path: "/inbound-shipments",
    name: "inbound-shipments-list",
    meta: { authRequired: true },
    component: () => import("./views/inbound-shipment/list"),
  },
  {
    path: "/inbound-shipments/create",
    name: "create-inbound-shipments",
    meta: { authRequired: true },
    component: () => import("./views/inbound-shipment/create"),
  },
  {
    path: "/inbound-shipments/:id",
    name: "inbound-shipment-details",
    meta: {
      authRequired: true,
    },
    props: true,
    component: () => import("./views/inbound-shipment/inbound-details"),
  },
  {
    path: "/orders/create",
    name: "order-create",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/order/create"),
  },
  {
    path: "/orders",
    name: "orders-list",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/order/list"),
  },
  {
    path: "/orders/:id",
    name: "order-details",
    meta: {
      authRequired: true,
    },
    props: true,
    component: () => import("./views/order/show"),
  },
  // returns
  {
    path: "/order-returns/create",
    name: "order-return-create",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/order-returns/create"),
  },
  {
    path: "/order-returns",
    name: "order-returns-list",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/order-returns/list"),
  },
  {
    path: "/order-returns/:id",
    name: "order-return-details",
    meta: {
      authRequired: true,
    },
    props: true,
    component: () => import("./views/order-returns/show"),
  },
  // support
  {
    path: "/support-tickets/create",
    name: "get-support",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/support-ticket/create"),
  },
  {
    path: "/support-tickets",
    name: "support-tickets-list",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/support-ticket/list"),
  },
  {
    path: "/support-tickets/:id",
    name: "support-ticket-details",
    meta: {
      authRequired: true,
    },
    props: true,
    component: () => import("./views/support-ticket/show"),
  },
  // Profile
  {
    path: "/account",
    name: "profile",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/account/profile"),
  },
  //Users-Control
  {
    path: "/users-control/create",
    name: "users-control",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/users-control/create"),
  },
  {
    path: "/users-control",
    name: "users-control-list",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/users-control/list"),
  },
  {
    path: "/users-control/:id",
    name: "users-control-details",
    meta: {
      authRequired: true,
    },
    props: true,
    component: () => import("./views/users-control/show"),
  },
  {
    path: "/integrations/:market_place/handshake",
    name: "integration-handshake",
    meta: {
      authRequired: false,
    },
    component: () => import("./views/integrations/handshake"),
  },
  {
    path: "/inventory",
    name: "inventory-list",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/inventory/list"),
  },
  {
    path: "/inventory/product-details/:product_id",
    name: "product-details",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/inventory/product-details"),
  },
  {
    path: "/development",
    name: "development-list",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/development/list"),
  },
  {
    path: "/development/create",
    name: "create-development",
    meta: { authRequired: true },
    component: () => import("./views/development/create"),
  },

  {
    path: "/integrations",
    name: "integrations-board",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/integrations/market-places"),
  },

  {
    path: "/integrations/:market_place/webhook/customers/data_request",
    name: "integration-webhook-customers-data-request",

    component: () => import("./views/integrations/webhook"),
  },
  {
    path: "/integrations/:market_place/webhook/customers/redact",
    name: "integration-webhook-customers-data-request",

    component: () => import("./views/integrations/webhook"),
  },
  {
    path: "/integrations/:market_place/webhook/shop/redact",
    name: "integration-webhook-customers-data-request",

    component: () => import("./views/integrations/webhook"),
  },
  {
    path: "/integrations/:market_place/redirect",
    name: "integration-redirect",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/integrations/redirect"),
  },
  {
    path: "/integrations/create",
    name: "integrations-form",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/integrations/create"),
  },
  /**Tracking-Order***/
  {
    path: "/tracking-order",
    name: "tracking-order",
    component: () => import("./views/tracking/tracking-order.vue"),
  },
  {
    path: "/tracking-order/:id",
    name: "tracking-details",
    component: () => import("./views/tracking/tracking-details.vue"),
  },
  /**Freights***/
  {
    path: "/freights",
    name: "freights-list",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/freights/list.vue"),
  },
  {
    path: "/freights/:id",
    name: "freights-details",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/freights/show.vue"),
  },
  {
    path: "/insights",
    name: "insights",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/freights/insights.vue"),
  },
];
